// React
import * as React from 'react';

// Router
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';

// Route Components
import NotFound from 'containers/NotFound';
import Consultations from 'containers/Consultations';
import { ExpertDetail } from 'containers/ExpertDetail';
import { CompanyDetail } from 'containers/CompanyDetail';
import ServiceDetail from 'containers/ServiceContainer/ServiceDetail';
import ServiceModules from 'containers/ServiceContainer/ServiceModules';
import ConsumerServiceList from 'containers/ServiceContainer/ConsumerServiceList';
import About from 'containers/About/About';
import AboutCorporate from 'containers/AboutCorporate/AboutCorporate';
import Contact from 'containers/Contact/Contact';
import ExpertSearch from 'containers/ExpertSearch';
import App from 'containers/App';
import ConsultCountdown from 'containers/ConsultCountdown';
import RebookingCalendar from 'containers/RebookingCalendar';
import HelpFeedback from 'containers/HelpFeedback/HelpFeedback';
import Marketplace from 'containers/Marketplace';
import TermsAndConditions from 'containers/TermsAndConditions';
import PrivacyPolicy from 'containers/PrivacyPolicy';

import ProServiceModules from 'containers/ServiceContainer/ProServiceModules';

export default (props) => (
    <Switch>
        {/* UNPROTECTED PROVIDER ROUTE */}
        {   !props.userId &&
            <Route path="/modules" component={ProServiceModules} />
        }
        
        {/* FOR PROACTIVE LAUNCH WE HAVE NO PUBLIC ROUTES EXCEPT THE LOGIN */}
        <Route exact path="/terms_and_conditions" component={ TermsAndConditions } />
        <Route exact path="/privacy_policy" component={ PrivacyPolicy } />
        {props.userId && <Route exact path="/search" component={ App } />}
        {props.userId && <Route exact path="/service-explorer" component={ Marketplace } />}
        {props.userId && <Route exact path="/expert/:id" component={ExpertDetail} />}
        {props.userId && <Route exact path="/company/:id" component={CompanyDetail} />}
        {props.userId && <Route exact path="/service/detail/:id" component={ServiceDetail} />}
        {props.userId && <Route path="/consultations/:id" component={Consultations} />}
        {props.userId && <Route path="/about" component={About} />}
        {props.userId && <Route path="/expert-search" component={ExpertSearch} />}
        {props.userId && <Route path="/about-corporate" component={AboutCorporate} />}
        {props.userId && <Route path="/Contact" component={Contact} />}
        {props.userId && <Route path="/help+feedback" component={HelpFeedback} />}
        {props.userId && <Route path="/check-back-soon/:id" component={ConsultCountdown} />}
        {props.userId && <Route path="/service/modules/:id?/:confirmation?" component={ServiceModules} />}
        {props.userId && <Route path="/my-services" component={ConsumerServiceList} />}
        {  !!props.userId && props.emailVerified &&
            <Route path="/my-services" component={ConsumerServiceList} />
        }
        {  !!props.userId && props.emailVerified &&
            <Route path="/calendar/rebook/:bookingKey/:serviceKey" component={ RebookingCalendar } />
        }

        <Route exact path="/" component={ App } />

        {/* IF NOT LOGGED IN SEND TO LOGIN PAGE */}
        { !props.userId && <Route path="*" component={App} /> }
        
        {/* { !props.userId && !props.emailVerified &&
            <PrivateRoute path="/service/modules/:id" component={null} /> // Navigate away if accesssing private route while unauthenticated
        } */}
        {/* PRIVATE ROUTES */}
        {/* { !!props.userId && props.emailVerified &&
            <Route path="/service/modules/:id/:confirmation?/:login?" component={ServiceModules} />
        } */}

        {/* PAGE NOT FOUND � 404 */}
        {
            setTimeout(() => <Route path="*" component={NotFound}/>, 1000)
        }
    </Switch>
)



// WEBPACK FOOTER //
// ./src/js/routes/ConsumerRoutes.jsx